import BasicButton from "@/UI/BasicButton";
import {
  NewOrderType,
  TNewOrderCountry,
  TNewOrderForm,
} from "@/entities/new-order";
import { getTotalCurrentTypeName } from "@/entities/new-order/utils";
import { Flex, Stack, Text } from "@mantine/core";
import { useFormContext, useWatch } from "react-hook-form";
import styles from "./country-item.module.scss";

type TCountryTotalBlockProps = {
  countryIndex: number;
  append: (value: TNewOrderForm["countriesList"][number]) => void;
};

export const CountryTotalBlock = ({
  countryIndex,
  append,
}: TCountryTotalBlockProps) => {
  const { control } = useFormContext<TNewOrderForm>();

  const type = useWatch({ control, name: "type" });
  const country = useWatch({
    control,
    name: `countriesList.${countryIndex}` as const,
  });

  if (!country) {
    return null;
  }

  const { impressions } = country;

  const handleCloneCountry = () => {
    const newCountry: TNewOrderCountry = JSON.parse(JSON.stringify(country));
    newCountry.geo = null;

    append(newCountry);
  };

  const totalValue = Object.values(country.keywords)
    .map((obj) => {
      const arr = Object.values(obj);
      const newArr = arr.map((num) => {
        if (typeof num === "number") {
          return Number(num);
        } else if (num && typeof num === "object" && "installs" in num) {
          return Number(num.installs);
        } else if (num && typeof num === "object" && "review" in num) {
          return 1;
        } else {
          return 0;
        }
      });
      return newArr.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0,
      );
    })
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  const totalImpressions = Object.values(country.keywords)
    .map((obj) => {
      const arr = Object.values(obj);
      const newArr = arr.map((num) => {
        if (typeof num === "number") {
          return 0;
        } else if (num && typeof num === "object" && "views" in num) {
          return Number(num.views ?? 0);
        } else {
          return 0;
        }
      });
      return newArr.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0,
      );
    })
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  return (
    <div className={styles.total}>
      {type !== NewOrderType.review ? (
        <BasicButton
          size="sm"
          variant="white"
          onClick={handleCloneCountry}
          text="Clone"
        />
      ) : (
        <Flex />
      )}
      {type ? (
        <Stack gap={0}>
          <Flex gap={16}>
            <Text>Total {getTotalCurrentTypeName(type)}:</Text>
            <Text className={styles.total__value}>{totalValue}</Text>
          </Flex>
          {Boolean(impressions?.type) && (
            <Flex gap={16}>
              <Text>Additional impressions:</Text>
              <Text className={styles.total__value}>{totalImpressions}</Text>
            </Flex>
          )}
        </Stack>
      ) : null}
    </div>
  );
};
